import { Injectable, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType} from '@ngrx/effects';
import { Observable } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import { LocalStorageService } from '@app/core';

import {
  SettingsActionTypes,
  selectorSettings
} from './settings.reducer';

@Injectable()
export class SettingsEffects {
  private actions$ = inject(Actions<Action>)
  private store = inject(Store<any>)
  private localStorageService = inject(LocalStorageService)

changeLoginMethod$ = createEffect(() => {
      return this.actions$
        .pipe(ofType(SettingsActionTypes.CHANGE_LOGIN_METHOD),
          tap((() => {
            this.store.select(selectorSettings)
              .pipe(first())
              .subscribe(
                settings => this.localStorageService.setItem('loginWithQr', settings.loginWithQR) // ! __________
              );
          }))
        );
    }, { dispatch: false })

}
